document.addEventListener("DOMContentLoaded", function () {
  const descriptionContainer = document.querySelector(".product__description.rte.quick-add-hidden");
  if (!descriptionContainer) return;

  let originalSections = [];

  function initializeSections() {
    originalSections = [];
    const headings = descriptionContainer.querySelectorAll("h3");

    headings.forEach((heading) => {
      const contentWrapper = document.createElement("div");
      contentWrapper.classList.add("accordion-content");
      contentWrapper.style.maxHeight = "0px";
      contentWrapper.style.overflow = "hidden";
      contentWrapper.style.transition = "max-height 0.3s ease-out";

      let nextElement = heading.nextElementSibling;
      while (nextElement && nextElement.tagName !== "H3") {
        const temp = nextElement.nextElementSibling;
        contentWrapper.appendChild(nextElement);
        nextElement = temp;
      }

      originalSections.push({ heading, contentWrapper });
    });

    // Add static section at the beginning
    const staticHeader = document.createElement("h3");
    staticHeader.textContent = "Free Shipping And Returns";

    const staticContent = document.createElement("div");
    staticContent.classList.add("accordion-content");
    staticContent.innerHTML = `
      <p>Coach ships to all areas of the Kingdom of Saudi Arabia. Delivery times commence from the date of order.<br>
      Please see the table below on shipping times and charges:</p>
      <table class="shipping-table" border="1" cellpadding="8" cellspacing="0" style="border-collapse: collapse; width: 100%;">
          <thead>
              <tr>
                  <th>Shipping Options</th>
                  <th>Price</th>
                  <th>Delivery Time</th>
              </tr>
          </thead>
          <tbody>
              <tr>
                  <td>Same Day Delivery (Riyadh)*</td>
                  <td>Free delivery over 500 SAR; else, 50 SAR delivery fee.</td>
                  <td>1 Business Day</td>
              </tr>
              <tr>
                  <td>Standard Delivery</td>
                  <td>Free delivery over 500 SAR; else, 50 SAR delivery fee.</td>
                  <td>3–4 Business Days</td>
              </tr>
          </tbody>
      </table>
      <p>Same Day Delivery is subject to product availability and limited to Riyadh. Orders must be placed by 1:00 PM Saudi time.</p>
      <p>For more on shipping, <a href="/pages/shipping">read here.</a></p>
    `;
    originalSections.unshift({ heading: staticHeader, contentWrapper: staticContent });
  }

  function renderAccordion() {
    descriptionContainer.innerHTML = "";

    originalSections.forEach(({ heading, contentWrapper }, index) => {
      heading.classList.add("accordion-header");
      heading.setAttribute("aria-expanded", "false");

      contentWrapper.style.maxHeight = "0px";
      contentWrapper.style.overflow = "hidden";
      contentWrapper.style.transition = "max-height 0.3s ease-out";

      // Make accordions non-exclusive
      heading.addEventListener("click", function () {
        const isOpen = contentWrapper.style.maxHeight !== "0px";

        if (isOpen) {
          contentWrapper.style.maxHeight = "0px";
          heading.classList.remove("open");
          heading.setAttribute("aria-expanded", "false");
        } else {
          contentWrapper.style.maxHeight = contentWrapper.scrollHeight + "px";
          heading.classList.add("open");
          heading.setAttribute("aria-expanded", "true");
        }
      });

      // Append to DOM
      descriptionContainer.appendChild(heading);
      descriptionContainer.appendChild(contentWrapper);

      // Open second and third accordion by default (index 1 and 2 since 0 is static section)
      if (index === 1 || index === 2) {
        contentWrapper.style.maxHeight = contentWrapper.scrollHeight + "px";
        heading.classList.add("open");
        heading.setAttribute("aria-expanded", "true");
      }
    });
  }

  // Initialize
  initializeSections();
  renderAccordion();

  // Re-render on resize
  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initializeSections();
      renderAccordion();
    }, 300);
  });
});
